import { defineStore } from 'pinia';

type SwaMeIdentity = {
  identityProvider?: string;
  userId?: string;
  userDetails?: string;
  userRoles?: string[];
};

type SwaMeResponse = { clientPrincipal?: SwaMeIdentity | null } | SwaMeIdentity[];

function normalizeMeResponse(payload: unknown): SwaMeIdentity | null {
  if (Array.isArray(payload)) {
    return (payload[0] as SwaMeIdentity) ?? null;
  }
  if (payload && typeof payload === 'object' && 'clientPrincipal' in payload) {
    const cp = (payload as { clientPrincipal?: SwaMeIdentity | null }).clientPrincipal;
    return cp ?? null;
  }
  return null;
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    loaded: false,
    userId: null as string | null,
    userDetails: null as string | null,
    roles: [] as string[]
  }),
  getters: {
    isAuthenticated: (s) => s.roles.includes('authenticated') || (!!s.userId && s.roles.length > 0),
    canUploadPreekrooster: (s) => s.roles.includes('preekrooster_upload')
  },
  actions: {
    async refresh() {
      try {
        const res = await fetch('/.auth/me', { cache: 'no-store' });
        if (!res.ok) {
          this.loaded = true;
          this.userId = null;
          this.userDetails = null;
          this.roles = [];
          return;
        }

        const payload = (await res.json()) as SwaMeResponse;
        const identity = normalizeMeResponse(payload);

        this.loaded = true;
        this.userId = identity?.userId ?? null;
        this.userDetails = identity?.userDetails ?? null;
        this.roles = identity?.userRoles ?? [];
      } catch {
        this.loaded = true;
        this.userId = null;
        this.userDetails = null;
        this.roles = [];
      }
    }
  }
});
